import colors from '../colors.js';
var e = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
export { e as default };
//# sourceMappingURL=category10.js.map
